import React, { useState } from "react";
import CountryFinderInput from "../../../CountryFinder";
import {
  InputPayment,
  PaymentFieldName,
  SplitRow,
} from "./PaymentModal/PaymentModalStyles";
import countries from "../../../../utils/countries.json";
import styled from "@emotion/styled";

interface IAddressInfoForm {
  address: {
    street: string;
    state_region: string;
    zip_code: string;
    country: string;
    city: string;
  };
  setAddress: (address: {
    street: string;
    state_region: string;
    zip_code: string;
    country: string;
    city: string;
  }) => void;
  errors: {
    street: boolean;
    state_region: boolean;
    zip_code: boolean;
    country: boolean;
    city: boolean;
  };
  disabled?: boolean;
}

export default function AddressInfoForm(props: IAddressInfoForm): JSX.Element {
  const { address, setAddress, errors, disabled } = props;

  function handleChangeStreet(event: React.ChangeEvent<HTMLInputElement>) {
    setAddress({
      street: event.target.value,
      state_region: address.state_region,
      country: address.country,
      zip_code: address.zip_code,
      city: address.city,
    });
  }
  function handleChangeState(event: React.ChangeEvent<HTMLInputElement>) {
    setAddress({
      street: address.street,
      state_region: event.target.value,
      country: address.country,
      zip_code: address.zip_code,
      city: address.city,
    });
  }
  function handleChangeZip(event: React.ChangeEvent<HTMLInputElement>) {
    setAddress({
      street: address.street,
      state_region: address.state_region,
      country: address.country,
      zip_code: event.target.value,
      city: address.city,
    });
  }

  function handleChangeCountry(country: string) {
    setAddress({
      street: address.street,
      state_region: address.state_region,
      country: countries.find((a) => a.key === country).text,
      zip_code: address.zip_code,
      city: address.city,
    });
  }

  function handleChangeCity(event: React.ChangeEvent<HTMLInputElement>) {
    setAddress({
      street: address.street,
      state_region: address.state_region,
      country: address.country,
      zip_code: address.zip_code,
      city: event.target.value,
    });
  }

  return (
    <div>
      <div style={{ width: "100%", paddingBottom: "20px" }}>
        <PaymentFieldName>Street Address</PaymentFieldName>
        <InputPayment
          onChange={handleChangeStreet}
          placeholder="Street Address"
          value={address.street}
          error={errors.street}
          disabled={disabled}
        />
      </div>
      <SplitRow>
        <div>
          <PaymentFieldName>City</PaymentFieldName>
          <InputPayment
            onChange={handleChangeCity}
            placeholder="City"
            error={errors.city}
            value={address.city}
            disabled={disabled}
          />
        </div>
        <div>
          <PaymentFieldName>State/Region</PaymentFieldName>
          <InputPayment
            onChange={handleChangeState}
            placeholder="State/Region"
            value={address.state_region}
            error={errors.state_region}
            disabled={disabled}
          />
        </div>
      </SplitRow>
      <SplitRow style={{ padding: "0" }}>
        <div>
          <PaymentFieldName>
            {address.country === "United States" ? "Zip Code" : "Postal Code"}
          </PaymentFieldName>
          <InputPayment
            onChange={handleChangeZip}
            placeholder={
              address.country === "United States" ? "Zip Code" : "Postal Code"
            }
            value={address.zip_code}
            error={errors.zip_code}
            disabled={disabled}
          />
        </div>
        <div>
          <PaymentFieldName style={{ marginBottom: "5px" }}>
            Country
          </PaymentFieldName>
          <CountryFinderInput
            style={{
              height: "42px",
              borderColor: "#eceeef",
              fontSize: "16px",
            }}
            setKey={handleChangeCountry}
          />
        </div>
      </SplitRow>
    </div>
  );
}
